import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { DynamicFormService } from '../../../../../../shared/components/dynamic-forms-components/dynamic-form.service';
import { FieldConfig, FieldType } from '../../../../../../shared/components/dynamic-forms-components/field.interface';
import { AppState } from '../../../../../../store';
import { StoreItemActions } from '../../../../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../../../../store/entities/store-item/store-item.model';
import { GET_ALL_USER } from '../../../../../../store/entities/user-management/users/users.graphql';
import { User } from '../../../../../../store/entities/user-management/users/users.model';
import { ASSIGN_PERSON_TO_WAREHOUSE, TRANSFER_WAREHOUSE_ASIGNEES } from '../../../../../../store/entities/warehouse-management/warehouse-assignee/warehouse-assignee.graphql';
import { Warehouse } from '../../../../../../store/entities/warehouse-management/warehouse/warehouse.model';
import { WarehouseAssignPersonComponent } from '../warehouse-assign-person/warehouse-assign-person.component';
import { GET_ALL_MSD_WAREHOUSE, GET_ALL_MSD_WAREHOUSE_DETAILED } from '../../../../../../store/entities/warehouse-management/warehouse/warehouse.graphql';
import { A } from '@angular/cdk/keycodes';
import { selectStoreItems } from '../../../../../../store/entities/store-item/store-item.selectors';
import { map } from 'rxjs';

@Component({
  selector: 'app-warehouse-transfer-person',
  templateUrl: './warehouse-transfer-person.component.html',
  styleUrl: './warehouse-transfer-person.component.scss'
})
export class WarehouseTransferPersonComponent implements OnInit {
  private dialogRef: MatDialogRef<WarehouseAssignPersonComponent> = inject(MatDialogRef<WarehouseAssignPersonComponent>)
  private dynamicFormService: DynamicFormService = inject(DynamicFormService);

  title: string;
  loading:boolean= false

  form: FormGroup
  fields: FieldConfig[] 
  userUniqueId: string
  selectedId: String
  deleteId:string
  optionList:any[] 

  constructor(
      private store: Store<AppState>,
      @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.deleteId = data?.data?.id
    this.userUniqueId=data?.userUniqueId
    this.selectedId = data?.warehouseUniqueId

    this.fields = this.formFields()
    this.optionList = [{label:"opt 1", value:"opt 1"},{label:"opt 1", value:"opt 1"},{label:"opt 1", value:"opt 1"}]
  }

  ngOnInit() {
    this.title = "Transfer Person";
    this.store.dispatch(StoreItemActions.getStoreItems({entity:StoreItemEntity.assigneeWarehouses,
      filtering:{
        userUniqueId:this.userUniqueId,
        pageNumber:1
      },
      query:GET_ALL_MSD_WAREHOUSE
    }))

    this.form = this.dynamicFormService.createControl(this.fields, {})
  }

  submitForm(formValue: any) {
    const input =  {
      ...formValue,
      fromWarehouse: this.selectedId,
      userUniqueId:this.userUniqueId
    };


    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity: StoreItemEntity.warehouseAssignee,
      input,
      mutation: TRANSFER_WAREHOUSE_ASIGNEES,
      isInput: true
    }))
    this.store.dispatch(StoreItemActions.deleteStoreItem({
      entity: StoreItemEntity.warehouseAssignee,
      id: this.deleteId
    }))
  }

  formFields(): FieldConfig[] {
    return [
      {
        type: FieldType.select,
        label: 'Warehouses',
        key: 'toWarehouse',
        options: this.store.select(selectStoreItems(StoreItemEntity.assigneeWarehouses))?.pipe(map(x => {
                  return x?.map(y => {
                    return {...y, value: y?.uniqueId}
                  })
                })),
        validations: [
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required',
          },
        ],
        rowClass: 'col-span-12',
      },
      {
        type: FieldType.button,
        label: 'Save',
        rowClass: 'col-span-12',
      },
    ];
  }
  closeModal() {
    this.dialogRef.close()
  }
}
